import React, {lazy, Suspense, useMemo} from "react";
import {useThemeSelector} from "../../../hooks/theme/useThemeSelector";
import {ThemeElementType} from "../../../hooks/theme/ThemeElementType";

interface ThemeProviderProps {
    children: React.ReactNode;
}

const EmergeStyle = lazy(() => import("./styles/EmergeStyle"))
const SquareOneStyle = lazy(() => import("./styles/SquareOneStyle"))
const VastBankStyle = lazy(() => import("./styles/VastBankStyle"))
const DefaultStyle = lazy(() => import("./styles/DefaultStyle"))

export const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {

    const { theme } = useThemeSelector()

    const ThemeElement = useMemo(() => {
        switch ((theme ?? "").toUpperCase()) {
            case ThemeElementType.EMERGE:
                return EmergeStyle;
            case ThemeElementType.SQUAREONE:
                return SquareOneStyle;
            case ThemeElementType.VASTBANK:
                return VastBankStyle;
            default:
                return DefaultStyle;
        }
    }, [theme])

    return (
        <>
            <Suspense fallback={<></>}>
                <ThemeElement />
            </Suspense>
            {children}
        </>
    )
}